<template>
    <v-container fluid :style="{'background-color':$store.getters.getColorPalette().backgroundColorCode}"> 
        <v-row>
            <v-col cols="12" align="center">
                <BatchTrackingPanel />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import BatchTrackingPanel from '@/components/panels/manufacturing/BatchTrackingPanel'
export default {
    name:'BatchTracking',
    components:{
        BatchTrackingPanel
    }
}
</script>